import { escapeRegExp, formatDateYMD, stripHtml, nameShortener } from 'helpers'
import { CourseNeutralPath, TrainerPrimaryPath } from 'navigation/Routes'
import { Helmet } from 'react-helmet'
import Text from './text.json'

export default ({ course, reviews, subscriptionMonthlyPrice }) => {
  const authorName = course?.Author ? `${course.Author.FirstName} ${course.Author.LastName}` : ''
  const linkToAuthor = `${Text.linkAlphorm}${TrainerPrimaryPath}/${course?.AuthorSlug}`
  const linkToCourse = `${Text.linkAlphorm}${CourseNeutralPath}/${course?.Slug}`
  const description = escapeRegExp(stripHtml(course.Description))
  const offers = course.isFree
    ? `"offers": [{
    "@type": "Offer",
    "category": "Free"
   }]`
    : `
  "offers": [{
    "@type": "Offer",
    "category": "Paid",
    "priceCurrency": "EUR",
    "price": ${course.Price}
   },
   {
    "@type": "Offer",
    "category": "Subscription",
    "priceCurrency": "EUR",
    "price": ${subscriptionMonthlyPrice}
   }]
    `

  return (
    <Helmet>
      <script type='application/ld+json'>
        {
        `
          {
            "@context": "https://schema.org",
            "@type": "Course",
            "provider": {
                "@type": "Organization",
                "name": "Alphorm", 
                "url": "https://www.alphorm.com", 
                "logo": "https://static.alphorm.com/logos/logosanslecture.png" 
            },
            "creator": {
                "@type": "Person",
                "name": "${authorName}",
                "sameAs": "${linkToAuthor}"
            },
            "url": "${linkToCourse}",
            "name": "${course.Title}",
            "description": "${description}",
            "image": "${course.Image}",
            "inLanguage": "fr", 
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.7",
            "reviewCount": "248"
          },
          ${offers},
          "hasCourseInstance": {
            "@type": "CourseInstance",
            "courseMode": "Online",
            "courseWorkload": "P2D"
          }
          ,
          "review": [
            ${
                reviews.map(review => (`
                  {
                    "@type": "Review",
                    "author": {
                      "@type": "Person",
                      "name": "${nameShortener({ firstName: review.FirstName, lastName: review.LastName }).trim() || 'Utilisateur'}"
                    },
                    "datePublished": "${formatDateYMD(review.ResponseDate)}",
                    "description": "${escapeRegExp(stripHtml(review.Opinion))}",
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "4.7"
                    }
                  }
                `))
            }
            ]
          }
        `
        }
      </script>
    </Helmet>
  )
}
